import services from '../createServices';

export const system = {
  config: params => services.get('/env/config', { params }),
  lists: params => services.get('/dmpFrame/loadSystemCfgRepo', { params })
};
